import { PoprService } from '../../components/popr/popr.service';
import { TwoFactorComponent } from '../../components/two-factor/two-factor.component';

import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { defaultIfEmpty, finalize, retryWhen, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TwoFactorInterceptor implements HttpInterceptor {
  constructor(
    private popr: PoprService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      retryWhen(notifier =>
        notifier.pipe(
          switchMap((error) => {
            if(error.error?.errors && error.error?.errors[0]?.code === 'STEPUP.AUTH.EXPIRED') {
              return this.elevateAuthority$().pipe(switchMap(isElevated =>
                isElevated ? of(true) : throwError(new Error('elevation failed'))
              ));
            }
            else {
              return throwError(error);
            }
          })
        )
      )
    );
  }

  /**
   * will open IFrame modal popup to elevate user's authority
   * it will allow save/update to proceed by returning true
   * incorrect user response returns false
   **/
  elevateAuthority$(): Observable<boolean> {
    const modal = this.popr.createModal(TwoFactorComponent);
    return modal.component$().pipe(
      switchMap(comp => comp.isElevatedAuthority$()),
      defaultIfEmpty(false),
      finalize(() => modal.close())
    );
  }
}
